import axios from "axios"

const api = axios.create({withCredentials: true})

export function requestFailed(error) {
    console.error(error)
    return {failed: true, status: error.response?.status}
}

export default api
